"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsonpath = _interopRequireDefault(require("jsonpath"));
var _reactRouterDom = require("react-router-dom");
var _dompurify = _interopRequireDefault(require("dompurify"));
var _useTranslation = _interopRequireDefault(require("../hooks/useTranslation"));
var _useConfig2 = _interopRequireDefault(require("./../hooks/useConfig"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var AddonDetails = function AddonDetails(_ref) {
  var bundleDetails = _ref.bundleDetails;
  var t = (0, _useTranslation.default)();
  var history = (0, _reactRouterDom.useHistory)();
  var _useConfig = (0, _useConfig2.default)(),
    detailsSections = _useConfig.detailsSections,
    termsAndConditions = _useConfig.termsAndConditions;
  var getSectionData = function getSectionData(section, bundleData) {
    return section.items.map(function (item, i, arr) {
      var text = _jsonpath.default.value(bundleData, item.jsonPath);
      var sanitizedText = function sanitizedText() {
        return {
          __html: _dompurify.default.sanitize(text)
        };
      };
      var isLastItem = arr.length - 1 === i;
      return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
        noGutters: true,
        key: i,
        marginBottom: isLastItem ? 0 : 4
      }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
        noGutters: true
      }, item.icon && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
        col: "auto"
      }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
        spacingLevel: {
          right: 4
        }
      }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Icon, {
        dataAttributes: {
          'data-testid': "".concat(section.key, "-").concat(i, "-icon")
        },
        name: item.icon,
        size: 5
      }))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
        spacingLevel: {
          bottom: 4
        }
      }, /*#__PURE__*/_react.default.createElement("span", {
        "data-testid": "".concat(section.key, "-").concat(i, "-text")
      }, /*#__PURE__*/_react.default.createElement("div", {
        dangerouslySetInnerHTML: sanitizedText()
      }))), !isLastItem && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, {
        level: 1,
        appearance: "primary",
        noMargin: true
      })))));
    });
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Accordion, {
    level: 1,
    initiallyOpenIds: '0'
  }, detailsSections.map(function (section, i) {
    return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.CollapsibleContainer, {
      key: section.key,
      id: i
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.CollapsibleContainerHeader, null, /*#__PURE__*/_react.default.createElement("div", {
      "data-testid": section.key
    }, t(section.key))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.CollapsibleContainerBody, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        top: 4,
        bottom: 4
      }
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, {
      level: 1,
      appearance: "primary",
      noMargin: true
    })), getSectionData(section, bundleDetails)));
  })), (termsAndConditions === null || termsAndConditions === void 0 ? void 0 : termsAndConditions.show) && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    noGutters: true,
    justify: "end",
    align: "center",
    marginTop: 4
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.LinkWithIcon, {
    dataAttributes: {
      'data-testid': 'terms&conditions'
    },
    appearance: "primary",
    text: t('termsAndConditions'),
    icon: {
      name: 'chevron-right',
      justify: 'right'
    },
    onClick: function onClick() {
      return history.push(termsAndConditions === null || termsAndConditions === void 0 ? void 0 : termsAndConditions.link);
    },
    size: 2
  })));
};
AddonDetails.propTypes = {
  bundleDetails: _propTypes.default.object
};
var _default = AddonDetails;
exports.default = _default;